export const getDownloadAllUserAcc = async (
  setDownloadAllUserAcc,
  setAuthenticationChecked,
) => {
  const endpoint = "/admin/users/download/all.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setDownloadAllUserAcc(res.data);
    });
    if (res.success === true) {
      setAuthenticationChecked("Success");
    } else if (
      res.error !== undefined &&
      res.error !== null &&
      res.error.code === "UNAUTHORIZED"
    ) {
      setAuthenticationChecked("UNAUTHORIZED");
    } else if (
      res.error !== undefined &&
      res.error !== null &&
      res.error.code === "FORBIDDEN"
    ) {
      setAuthenticationChecked("FORBIDDEN");
    }
    if (!res.ok) {
      if (res.status === 403) {
        setAuthenticationChecked("FORBIDDEN");
      }
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {
    if (err.message.indexOf("401") > -1) {
      setAuthenticationChecked("UNAUTHORIZED");
    } else if (err.message.indexOf("403") > -1) {
      setAuthenticationChecked("FORBIDDEN");
    }
  }
};

export const getDownloadUserAcc = async (userId, setDownloadUserAcc) => {
  const endpoint = "/admin/users/download/" + userId + "/user.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setDownloadUserAcc(res.data);
    });
    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const updateUserAcc = async (userAcc) => {
  const endpoint = "/admin/users/download/" + userAcc.id + "/user.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(userAcc),
    });
    res.json().then((res) => {
      if (res.success)
        alert("Account" + userAcc.id + "has been updated successfully.");
      else
        alert(
          "Account" +
            userAcc.id +
            "update went something wrong.." +
            res.error.message,
        );
    });

    if (!res.ok) {
      if (res.status === 403) {
        alert(
          "Access denied - You don't have the required permissions to view this page.",
        );
        return;
      }
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {
    if (err.message.indexOf("403") > -1) {
      alert(
        "Access denied - You don't have the required permissions to view this page.",
      );
    } else {
      alert("Something went wrong: " + err.message);
    }
  }
};

export const deleteUserAcc = async (userAcc) => {
  const endpoint = "/admin/users/download/" + userAcc.id + "/user.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "DELETE",
    });
    res.json().then((res) => {
      if (res.success)
        alert("Account" + userAcc.id + "has been successfully deleted.");
      else alert("Account " + userAcc.id + "deletion went wrong");
    });
    // if(!res.ok){
    //     throw new Error(`Error ${res.status}: ${res.statusText}`)
    // }
  } catch (err) {
    alert("Something went wrong.." + err);
  }
};

export const getRoles = async (id, setRoles) => {
  const endpoint = "/admin/users/download/roles.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setRoles(res.data);
    });
    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};
